import React, { Component } from "react";
import {
  Row,
  Nav,
  NavItem,
  NavLink,
  TabPane,
  TabContent,
  Col,
  FormGroup,
  Label,
  Table,
  Input,
  Button,
  InputGroup,
  InputGroupAddon,
  Modal,
  ModalHeader,
  ModalBody,
  CustomInput,
  Spinner,
} from "reactstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import classnames from "classnames";
import { AvForm, AvField } from "availity-reactstrap-validation";
import Select from "react-select";
import moment from "moment";
import DefaultImg from "../../../assets/images/product/Default_img.jpg";

import {
  InputChangeValue,
  SelecteChangeValue,
  SelectedProducts,
  model_open,
  model_close,
  getAllProducts,
  getRowProducts,
  CProductImage,
  CProductChangeValue,
  CProductSelecteChangeValue,
  AddCustomProduct,
  SetParams,
  toggleTab,
  uploadMultipleSRItemImages,
} from "../../../store/ServiceRequest/actions";

class AddServiceItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: 1,
      file: [null],
      fileObj: [],
      fileArray: [],
    };

    this.ChangeHandeler = this.ChangeHandeler.bind(this);
    this.addtocartProduct = this.addtocartProduct.bind(this);
    this.CPChangeHandeler = this.CPChangeHandeler.bind(this);
    this.handleCustomProductSubmit = this.handleCustomProductSubmit.bind(this);
    this.openPage = this.openPage.bind(this);
    // this.uploadMultipleFiles = this.uploadMultipleFiles.bind(this);
  }

  ChangeHandeler(e) {
    this.props.InputChangeValue({
      key: e.target.name,
      value: e.target.value,
    });
  }
  handleSearch = (e) => {
    if (e.key === "Enter") {
      this.props.SetParams({
        ...this.props.params,
        search: e.target.value,
        page: 1,
      });
      this.props.getAllProducts(
        {
          ...this.props.params,
          search: e.target.value,
          page: 1,
          type:2
        },
        true
      );
    }
  };
  autohandleSearch = (e) => {
    this.props.SetParams({
      ...this.props.params,
      search: e.target.value,
      page: 1,
    });
    if (e.target.value === "") {
      this.props.getAllProducts(
        {
          ...this.props.params,
          search: e.target.value,
          page: 1,
          type:2
        },
        true
      );
    }
  };
  backtoList() {
    this.addForm && this.addForm.reset();
    this.props.toggleTab(1);
  }
  addtocartProduct() {
    this.addForm && this.addForm.reset();
    var products = this.props.rowdata;
    this.props.SelectedProducts({
      products: {
        ...products,
        date:
          this.props.rowdata.date == null
            ? moment(new Date()).format("YYYY-MM-DD")
            : this.props.rowdata.date,
        unitsLabel:
          this.props.rowdata.unitsLabel == null
            ? this.props.productRowlist?.units[0].name
            : this.props.rowdata.unitsLabel,
        unit_id:
          this.props.rowdata.unit_id == null
            ? this.props.productRowlist?.units[0].id
            : this.props.rowdata.unit_id,
        product_id: this.props.productRowlist.id,
        department: {
          id: this.props.productRowlist.department.id,
          name: this.props.productRowlist.department.name,
        },
        name: this.props.productRowlist.name,
        image: this.props.productRowlist.image,
      },
    });
    if (this.props.params.search !== "") {
      this.props.SetParams({
        ...this.props.params,
        search: "",
        page: 1,
      });
      this.props.getAllProducts(
        {
          ...this.props.params,
          search: "",
          page: 1,
          type:2
        },
        true
      );
    }

    this.props.toggleTab(1);
  }

  CPChangeHandeler(e) {
    this.props.CProductChangeValue({
      key: e.target.name,
      value: e.target.value,
    });
  }
  resetFrom() {
    this.form && this.form.reset();
    if (this.props.params.search !== "") {
      this.props.SetParams({
        ...this.props.params,
        search: "",
        page: 1,
      });
      this.props.getAllProducts(
        {
          ...this.props.params,
          search: "",
          page: 1,
          type:2
        },
        true
      );
    }
  }
  // CustomProduct() {
  //   this.form && this.form.reset();
  //   this.props.toggleTab(3);
  // }
  handleCustomProductSubmit() {
    // if (this.props.cPimage !== "") {
    var CustomProductData = {
      name: this.props.cPRowData.name,
      department_id: this.props.cPRowData.department_id,
      baseunit_id: this.props.cPRowData.baseunit_id,
      units: [{ name: this.props.cPRowData.baseunitLabel, units: 1 }],
    };

    this.props.AddCustomProduct({
      CustomProductData,
      cPimage: this.props.cPimage,
      FromReset: () => this.resetFrom(),
    });
    // } else {
    //   Swal.fire({
    //     icon: "error",
    //     title: "Select Image",
    //   });
    // }
  }
  handleImageChange(e) {
    if (e.target.files[0]) {
      let reader = new FileReader();
      let file = e.target.files[0];

      reader.onloadend = () => {
        this.props.CProductImage({
          file: file,
          imagePreviewUrl: reader.result,
        });
      };
      reader.readAsDataURL(file);
    } else {
      this.props.CProductImage({
        file: {},
        imagePreviewUrl: null,
      });
    }
  }
  openPage(pageNo) {
    this.props.SetParams({
      ...this.props.params,
      page: pageNo,
    });
    this.props.getAllProducts(
      {
        ...this.props.params,
        page: pageNo,
        type:2
      },
      false
    );
  }
  handleScroll = (e) => {
    const target = e.target;
    if (target.scrollTop !== 0) {
      if (target.scrollHeight - target.scrollTop === target.clientHeight) {
        if (this.props.params.page <= this.props.params.no_of_pages) {
          this.openPage(this.props.params.page + 1);
        }
      }
    }
  };

  uploadMultipleFiles(e, ProductId) {
    this.props.uploadMultipleSRItemImages(e.target.files, ProductId);
    this.state.fileObj.push(e.target.files);
    for (let i = 0; i < this.state.fileObj[0].length; i++) {
      this.state.fileArray.push(URL.createObjectURL(this.state.fileObj[0][i]));
    }
    this.setState({ file: this.state.fileArray, fileObj: [] });
  }

  render() {
    var data = this.props.productslist;

    let { imagePreviewUrl } = this.props;
    let $imagePreview = null;
    if (imagePreviewUrl) {
      $imagePreview = (
        <img className="product-img" alt="User" src={imagePreviewUrl} />
      );
    } else {
      $imagePreview = (
        <div
          className="img-thumbnail text-center pt-2 "
          style={{
            height: "300px",
            width: "300px",
            cursor: "pointer",
          }}
        >
          <i className="ri-upload-cloud-line ri-8x"></i>
          <br />
          <span className="font-size-16">Select Product Image</span>
        </div>
      );
    }

    return (
      <React.Fragment>
        <Modal isOpen={this.props.model} backdrop="static" centered size="lg">
          <ModalHeader
            toggle={() => {
              this.props.model_close();
              this.props.toggleTab(1);
            }}
          >
            Add Item
          </ModalHeader>
          <ModalBody className="pt-0 pb-2">
            <Row className="justify-content-center">
              <Col md={12}>
                <Row>
                  <Col lg={12}>
                    <Nav tabs className="nav-tabs-custom mb-2">
                      {(this.props.activeTab === 1 ||
                        this.props.activeTab === 2 ||
                        this.props.activeTab === 4 ||
                        this.props.activeTab === 5) && (
                        <NavItem>
                          <NavLink
                            onClick={() => {
                              this.props.toggleTab(1);
                            }}
                            className={classnames(
                              { active: this.props.activeTab === 1 },
                              "pt-3 font-weight-bold card-title-16"
                            )}
                          >
                            Items List |<span> {this.props.productsCount}</span>
                          </NavLink>
                        </NavItem>
                      )}
                      {(this.props.activeTab === 2 ||
                        this.props.activeTab === 4 ||
                        this.props.activeTab === 5) && (
                        <NavItem>
                          <NavLink
                            onClick={() => {
                              this.props.toggleTab(2);
                            }}
                            className={classnames(
                              { active: this.props.activeTab === 2 },
                              "pt-3 font-weight-bold card-title-16"
                            )}
                          >
                            Details
                          </NavLink>
                        </NavItem>
                      )}
                      {this.props.activeTab === 3 && (
                        <NavItem>
                          <NavLink
                            onClick={() => {
                              this.props.toggleTab(3);
                            }}
                            className={classnames(
                              { active: this.props.activeTab === 3 },
                              "pt-3 font-weight-bold card-title-16"
                            )}
                          >
                            Custom Item
                          </NavLink>
                        </NavItem>
                      )}
                      {(this.props.activeTab === 2 ||
                        this.props.activeTab === 4 ||
                        this.props.activeTab === 5) && (
                        <NavItem>
                          <NavLink
                            onClick={() => {
                              this.props.toggleTab(4);
                            }}
                            className={classnames(
                              { active: this.props.activeTab === 4 },
                              "pt-3 font-weight-bold card-title-16"
                            )}
                          >
                            Units
                          </NavLink>
                        </NavItem>
                      )}
                      {this.props.activeTab === 5 && (
                        <NavItem>
                          <NavLink
                            onClick={() => {
                              this.props.toggleTab(5);
                            }}
                            className={classnames(
                              { active: this.props.activeTab === 5 },
                              "pt-3 font-weight-bold card-title-16"
                            )}
                          >
                            Image Upload
                          </NavLink>
                        </NavItem>
                      )}
                    </Nav>
                    <TabContent activeTab={this.props.activeTab}>
                      <TabPane tabId={1}>
                        <div className="mt-2">
                          <FormGroup className="m-0">
                            <InputGroup>
                              <Input
                                type="text"
                                name="search"
                                className="form-control d-inline-block"
                                placeholder="Search Item"
                                value={this.props.params.search}
                                onChange={(e) => this.autohandleSearch(e)}
                                onKeyDown={(e) => this.handleSearch(e)}
                              />
                              <InputGroupAddon addonType="append">
                                {this.props.params.search !== "" && (
                                  <Button
                                    color="light"
                                    type="button"
                                    onClick={() => {
                                      this.props.SetParams({
                                        ...this.props.params,
                                        search: "",
                                        page: 1,
                                        // department:
                                        //   this.props.mrRowData.department_id,
                                      });
                                      this.props.getAllProducts(
                                        {
                                          search: "",
                                          page: 1,
                                          type:2
                                          // department:
                                          //   this.props.mrRowData.department_id,
                                        },
                                        true
                                      );
                                    }}
                                  >
                                    <i className="text-danger ri-close-line"></i>
                                  </Button>
                                )}

                                <Button
                                  color="light"
                                  type="button"
                                  onClick={() => {
                                    this.props.getAllProducts(
                                      {
                                        search: this.props.params.search,
                                        page: 1,
                                        type:2
                                        // department:
                                        //   this.props.mrRowData.department_id,
                                      },
                                      true
                                    );
                                  }}
                                >
                                  <i className="ri-search-line"></i> Search
                                </Button>
                              </InputGroupAddon>
                            </InputGroup>
                          </FormGroup>

                          {/* {this.props.dataLoading === true && (
                            <Spinner color="primary" />
                          )} */}
                        </div>

                        <div>
                          <div
                            className="table-responsive mt-2"
                            onScroll={this.handleScroll}
                            style={{
                              height: "450px",
                              overflowY: "auto",
                            }}
                          >
                            <Table className="table-centered mb-0">
                              <thead className="bg-light ">
                                <tr>
                                  <th style={{ width: "120px" }}>
                                    Item Images
                                  </th>
                                  <th style={{ width: "220px" }}>Item Name</th>
                                  <th style={{ width: "120px" }}>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.props.productsCount === 0 ? (
                                  <>
                                    {this.props.dataLoading === true ? (
                                      <tr className="text-center">
                                        <td colSpan="3">
                                          <Spinner color="primary" />
                                        </td>
                                      </tr>
                                    ) : (
                                      <tr className="text-center">
                                        <td colSpan="3">
                                          No Items Found.{" "}
                                          <Link
                                            to="/AddProducts/0"
                                            onClick={() => {
                                                this.props.model_close();
                                            }}
                                          >
                                            Add Product
                                          </Link>
                                        </td>
                                      </tr>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {data.length === 0 ? (
                                      <>
                                        {this.props.dataLoading === true ? (
                                          <tr className="text-center">
                                            <td colSpan="3">
                                              <Spinner color="primary" />
                                            </td>
                                          </tr>
                                        ) : (
                                          <tr className="text-center">
                                            <td
                                              colSpan="3"
                                              className="text-danger"
                                            >
                                              Already item has been added in the
                                              List
                                            </td>
                                          </tr>
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        {data?.map((product, key) => (
                                          <tr key={key}>
                                            <td className="nowrap ">
                                              <img
                                                src={
                                                  product.image == null
                                                    ? DefaultImg
                                                    : product.image
                                                }
                                                alt="product-img"
                                                title="product-img"
                                                className="avatar-sm"
                                              />
                                            </td>
                                            <td>
                                              <div className="font-size-12">
                                                {product.code === "nan"
                                                  ? "-"
                                                  : product.code}
                                              </div>
                                              <h5 className="mb-0 font-size-14 text-truncate">
                                                <Link
                                                  to="#"
                                                  className="text-dark"
                                                  onClick={() => {
                                                    this.props.toggleTab(2);
                                                    this.props.getRowProducts(
                                                      product.id
                                                    );
                                                    this.addForm &&
                                                      this.addForm.reset();
                                                  }}
                                                >
                                                  {product.name}
                                                </Link>
                                              </h5>
                                            </td>

                                            <td className="nowrap">
                                              <Button
                                                type="sudmit"
                                                color="primary"
                                                className="waves-effect waves-light mr-2"
                                                onClick={() => {
                                                  this.props.toggleTab(2);
                                                  this.props.getRowProducts(
                                                    product.id
                                                  );
                                                  this.addForm &&
                                                    this.addForm.reset();
                                                }}
                                              >
                                                <i className="mdi mdi-arrow-top-right mr-2"></i>
                                                Add
                                              </Button>
                                            </td>
                                          </tr>
                                        ))}
                                        {this.props.dataLoading === true && (
                                          <tr className="text-center">
                                            <td colSpan="3">
                                              <Spinner color="primary" />
                                            </td>
                                          </tr>
                                        )}
                                      </>
                                    )}
                                  </>
                                )}
                                {/* </>
                                )} */}
                              </tbody>
                            </Table>
                          </div>
                        </div>
                      </TabPane>
                      <TabPane tabId={2}>
                        <Row>
                          <Col md={5}>
                            <div className="product-detail text-center">
                              <img
                                src={
                                  this.props.productRowlist?.image == null
                                    ? DefaultImg
                                    : this.props.productRowlist?.image
                                }
                                alt="product-img"
                                title="product-img"
                                className="product-img  img-fluid mx-auto tab-img rounded"
                              />
                            </div>
                          </Col>
                          <Col md={7}>
                            <h5 className="mt-1 mb-1">
                              {this.props.productRowlist?.name}
                            </h5>
                            <div>
                              <p className="d-inline-block">
                                <span style={{ fontWeight: "bold" }}>
                                  Code :
                                </span>
                                <i>
                                  {this.props.productRowlist?.code === "nan"
                                    ? "***"
                                    : this.props.productRowlist?.code}
                                </i>
                              </p>
                              <p className="float-right d-inline-block mr-5">
                                <span style={{ fontWeight: "bold" }}>
                                  Section :
                                </span>
                                <i>{this.props.productRowlist?.section.name}</i>
                              </p>
                            </div>
                            <Row>
                              <Col md={12}>
                                <div className="Order-panel-content">
                                  <div className="list-column">
                                    <ul className="list-style-two p-0 product-desc-list">
                                      <li className="clearfix">
                                        <span className="ttl">
                                          <i className="mdi mdi-circle-medium mr-1 align-middle"></i>
                                          Available Qty :
                                        </span>
                                        <span className="dtl">
                                          {this.props.productStoreQty.qty}
                                        </span>
                                      </li>
                                      <li className="clearfix">
                                        <span className="ttl">
                                          <i className="mdi mdi-circle-medium mr-1 align-middle"></i>
                                          Department :
                                        </span>
                                        <span className="dtl">
                                          {
                                            this.props.productRowlist
                                              ?.department.name
                                          }
                                        </span>
                                      </li>
                                      <li className="clearfix">
                                        <span className="ttl">
                                          <i className="mdi mdi-circle-medium mr-1 align-middle"></i>
                                          Category :
                                        </span>
                                        <span className="dtl">
                                          {this.props.productRowlist?.category
                                            .name === "nan"
                                            ? "-"
                                            : this.props.productRowlist
                                                ?.category.name}
                                        </span>
                                      </li>
                                      <li className="clearfix">
                                        <span className="ttl">
                                          <i className="mdi mdi-circle-medium mr-1 align-middle"></i>
                                          Product Group :
                                        </span>
                                        <span className="dtl">
                                          {
                                            this.props.productRowlist?.group
                                              .name
                                          }
                                        </span>
                                      </li>
                                      <li className="clearfix">
                                        <span className="ttl">
                                          <i className="mdi mdi-circle-medium mr-1 align-middle"></i>
                                          Base Unit :
                                        </span>
                                        <span className="dtl">
                                          {
                                            this.props.productRowlist?.baseunit
                                              .name
                                          }
                                        </span>
                                      </li>
                                      <li className="clearfix">
                                        <span className="ttl">
                                          <i className="mdi mdi-circle-medium mr-1 align-middle"></i>
                                          Specifications :
                                        </span>
                                        {this.props.productRowlist
                                          ?.description !== null ? (
                                          <span
                                            className="font-weight-medium"
                                            dangerouslySetInnerHTML={{
                                              __html:
                                                this.props.productRowlist?.description.replaceAll(
                                                  "\n",
                                                  "<br/>"
                                                ),
                                            }}
                                          ></span>
                                        ) : (
                                          <span className="font-weight-medium">
                                            {
                                              this.props.productRowlist
                                                ?.description
                                            }
                                          </span>
                                        )}
                                        {/* <span
                                          className="dtl"
                                          dangerouslySetInnerHTML={{
                                            __html:
                                              this.props.productRowlist?.description.replaceAll(
                                                "\n",
                                                "<br/>"
                                              ),
                                          }}
                                        ></span> */}
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <hr className="my-1" />
                            <Col md={12}>
                              <AvForm
                                className="form-horizontal"
                                onValidSubmit={() => {
                                  this.props.toggleTab(5);
                                  this.setState({ file: [], fileArray: [] });
                                }}
                                ref={(c) => (this.addForm = c)}
                              >
                                <Row>
                                  <Col md={5}>
                                    <FormGroup>
                                      {/* <AvField name="qty"
                                        label="Quantity"
                                        min={0}
                                        type="number"
                                        value={this.props.rowdata?.qty}
                                        onChange={this.ChangeHandeler}
                                        validate={{
                                          required: { value: true },
                                          pattern: { value: '^[0-9]{1,18}([.-]?)[0-9]{0,3}$', errorMessage: 'Qty can compose numbers and 3 decimals and two decimals ' },
                                        }}
                                      /> */}
                                      <Label htmlFor="item_qty">
                                        Quantity{" "}
                                        <span className="text-danger">*</span>
                                      </Label>
                                      <AvField
                                        className="mb-0  "
                                        min={0}
                                        // max={7}
                                        type="number"
                                        // step="1"
                                        name="qty"
                                        id="item_qty"
                                        value={this.props.rowdata?.qty}
                                        onChange={this.ChangeHandeler}
                                        validate={{
                                          required: { value: true },
                                          pattern: {
                                            value:
                                              "^[0-9]{1,18}([.-]?)[0-9]{0,3}$",
                                            errorMessage:
                                              "Qty can compose numbers and 3 decimals",
                                          },
                                        }}
                                        placeholder="Qty"
                                      />
                                    </FormGroup>
                                  </Col>
                                  <Col md={3}>
                                    <FormGroup>
                                      <Label htmlFor="units_select">
                                        Units
                                        <span className="text-danger">*</span>
                                      </Label>
                                      <Select
                                        id="units_select"
                                        name="units_select"
                                        required="required"
                                        options={this.props.productRowlist?.units.map(
                                          (item) => ({
                                            label: item.name,
                                            value: item.id,
                                          })
                                        )}
                                        value={{
                                          label:
                                            this.props.rowdata?.unitsLabel ==
                                            null
                                              ? this.props.productRowlist
                                                  ?.units[0].name
                                              : this.props.rowdata?.unitsLabel,
                                          value:
                                            this.props.rowdata?.unit_id == null
                                              ? this.props.productRowlist
                                                  ?.units[0].id
                                              : this.props.rowdata?.unit_id,
                                        }}
                                        onChange={(e) => {
                                          this.props.SelecteChangeValue({
                                            key: "unitsLabel",
                                            label: e.label,
                                            key2: "unit_id",
                                            value: e.value,
                                          });
                                        }}
                                      />
                                    </FormGroup>
                                  </Col>
                                  <Col md={4}>
                                    <FormGroup>
                                      <Label htmlFor="requiredDate">
                                        Required Date{" "}
                                        <span className="text-danger">*</span>
                                      </Label>
                                      <AvField
                                        type="date"
                                        name="date"
                                        min={moment(new Date()).format(
                                          "YYYY-MM-DD"
                                        )}
                                        id="requiredDate"
                                        className="mb-0 form-control "
                                        placeholder="Select Date"
                                        value={
                                          this.props.rowdata.date == null
                                            ? moment(new Date()).format(
                                                "YYYY-MM-DD"
                                              )
                                            : this.props.rowdata?.date
                                        }
                                        onChange={this.ChangeHandeler}
                                        validate={{
                                          required: { value: true },
                                        }}
                                      />
                                    </FormGroup>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col md={5}>
                                    <FormGroup>
                                      <Label htmlFor="Make">
                                        Make{" "}
                                        <span className="text-danger">*</span>
                                      </Label>
                                      <AvField
                                        type="textarea"
                                        name="make"
                                        id="Make"
                                        className="mb-0 form-control "
                                        placeholder="Add Make"
                                        value={this.props.rowdata?.make}
                                        onChange={this.ChangeHandeler}
                                        validate={{
                                          required: { value: true },
                                          maxLength: {
                                            value: 100,
                                            errorMessage:
                                              "Your name must only 100 characters",
                                          },
                                        }}
                                      />
                                    </FormGroup>
                                  </Col>

                                  <Col md={7}>
                                    <FormGroup>
                                      <Label htmlFor="Description">
                                        Description
                                      </Label>
                                      <AvField
                                        type="textarea"
                                        name="description"
                                        id="Description"
                                        className="mb-0 form-control "
                                        placeholder="Add Description"
                                        value={this.props.rowdata?.description}
                                        onChange={this.ChangeHandeler}
                                      />
                                    </FormGroup>
                                  </Col>
                                  <Col md={12}>
                                    <div className="float-right">
                                      <FormGroup>
                                        <Button
                                          type="button"
                                          color="light "
                                          className="waves-effect waves-light d-inline-block mr-2"
                                          onClick={() => {
                                            this.backtoList();
                                          }}
                                        >
                                          Back To List
                                        </Button>

                                        <Button
                                          type="submit"
                                          color="primary"
                                          className="waves-effect waves-light d-inline-block"
                                        >
                                          <i className="mdi mdi-plus mr-1"></i>
                                          Next {/* Add Item */}
                                        </Button>
                                      </FormGroup>
                                    </div>
                                  </Col>
                                </Row>
                              </AvForm>
                            </Col>
                          </Col>
                        </Row>
                      </TabPane>
                      <TabPane tabId={5}>
                        <div
                          style={{
                            minHeight: "450px",
                          }}
                        >
                          <Row>
                            <Col md={12}>
                              <form>
                                <div className=" mt-2 ">
                                  {this.state.fileArray?.map((url) => (
                                    <div className="product-detail mt-0 text-center d-inline-block">
                                      <img
                                        src={url}
                                        alt="..."
                                        className="product-img  img-fluid mx-auto tab-img rounded"
                                        style={{
                                          height: "150px",
                                          width: "250px",
                                        }}
                                      />
                                    </div>
                                  ))}
                                </div>
                                <div className=" mt-2 ">
                                  <label htmlFor="ItemsImageupload">
                                    <div
                                      className="img-thumbnail text-center W-100 "
                                      style={{
                                        height: "130px",
                                        width: "230px",
                                        cursor: "pointer",
                                      }}
                                    >
                                      <i className="ri-upload-cloud-line ri-4x"></i>
                                      <br />
                                      <span className="font-size-16">
                                        Select Item Image
                                      </span>
                                    </div>
                                  </label>

                                  <div className=" d-none">
                                    <input
                                      type="file"
                                      id="ItemsImageupload"
                                      className="form-control"
                                      onChange={(e) => {
                                        this.uploadMultipleFiles(
                                          e,
                                          this.props.productRowlist.id
                                        );
                                      }}
                                      multiple
                                      accept="image/*"
                                    />
                                  </div>
                                </div>

                                {/* <div className="form-group">
                                  <input
                                    type="file"
                                    className="form-control"
                                    onChange={this.uploadMultipleFiles}
                                    multiple
                                    accept="image/*"
                                  />
                                </div> */}
                                {/* <button
                                  type="button"
                                  className="btn btn-danger btn-block"
                                  onClick={this.uploadFiles}
                                >
                                  Upload
                                </button> */}
                              </form>
                            </Col>
                            <Col>
                              <div className="float-right">
                                <Button
                                  type="button"
                                  color="primary"
                                  className="waves-effect waves-light d-inline-block float-right mt-2"
                                  onClick={() => {
                                    this.addtocartProduct();
                                  }}
                                >
                                  <i className="mdi mdi-plus mr-1"></i>
                                  Add Item
                                </Button>
                                <Button
                                  type="button"
                                  color="light"
                                  className="waves-effect waves-light mr-2 mt-2"
                                  onClick={() => {
                                    this.props.toggleTab(2);

                                    this.setState({ file: [], fileArray: [] });

                                    // this.uploadMultipleFiles = [];
                                  }}
                                >
                                  Back To Product
                                </Button>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </TabPane>
                      <TabPane tabId={4}>
                        <div
                          style={{
                            minHeight: "450px",
                          }}
                        >
                          <Row>
                            <Col md={12}>
                              <div className="table-responsive table-bordered m-2">
                                <Table className="table-centered mb-0">
                                  <thead className="bg-light ">
                                    <tr>
                                      <th style={{ width: "120px" }}>S.No</th>
                                      <th style={{ width: "220px" }}>
                                        Units Name
                                      </th>
                                      <th style={{ width: "120px" }}>Units</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {this.props.productRowlist?.units.map(
                                      (unit, key) => (
                                        <tr key={key}>
                                          <td className="nowrap ">{key + 1}</td>
                                          <td>{unit.name}</td>
                                          <td>{unit.units}</td>
                                        </tr>
                                      )
                                    )}
                                  </tbody>
                                </Table>
                              </div>
                            </Col>
                            <Col>
                              <Button
                                type="button"
                                color="light"
                                className="waves-effect waves-light float-right mt-2"
                                onClick={() => {
                                  this.props.toggleTab(2);
                                }}
                              >
                                Back To Product
                              </Button>
                            </Col>
                          </Row>
                        </div>
                      </TabPane>
                      <TabPane tabId={3}>
                        <div
                          style={{
                            minHeight: "450px",
                          }}
                        >
                          <AvForm
                            className="form-horizontal"
                            onValidSubmit={this.handleCustomProductSubmit}
                            ref={(c) => (this.form = c)}
                          >
                            <Row>
                              <Col md={5} lg={5}>
                                <div className="product-detail">
                                  <div className="mt-2 align-items-center ">
                                    <label
                                      htmlFor="customItemFile"
                                      className="mt-4 text-center"
                                    >
                                      {$imagePreview}
                                    </label>

                                    <CustomInput
                                      type="file"
                                      className="file-upload"
                                      id="customItemFile"
                                      accept="image/*"
                                      multiple={false}
                                      onChange={(e) =>
                                        this.handleImageChange(e)
                                      }
                                    />
                                  </div>
                                </div>
                              </Col>
                              <Col md={7} lg={7}>
                                <Row>
                                  <Col md={12}>
                                    <FormGroup className="mb-0">
                                      <Label
                                        htmlFor="CProduct-Name-text-input"
                                        className="col-form-label p-0"
                                      >
                                        Item Name
                                      </Label>

                                      <AvField
                                        className="mb-0 form-control "
                                        type="text"
                                        value={this.props.cPRowData?.name}
                                        onChange={this.CPChangeHandeler}
                                        id="CProduct-Name-text-input"
                                        name="name"
                                        placeholder="Product Name"
                                        validate={{
                                          required: { value: true },
                                        }}
                                      />
                                      {this.props.error_msg && (
                                        <span className="text-danger mt-0">
                                          {this.props.error_msg?.name}
                                        </span>
                                      )}
                                    </FormGroup>
                                  </Col>
                                  <Col md={6}>
                                    <FormGroup className="mb-0">
                                      <Label
                                        htmlFor="CProduct-Quantity-text-input"
                                        className="col-form-label p-0"
                                      >
                                        Quantity
                                      </Label>

                                      <AvField
                                        className="mb-0 form-control "
                                        type="number"
                                        min={1}
                                        value={this.props.cPRowData?.citem_qty}
                                        onChange={this.CPChangeHandeler}
                                        id="CProduct-Quantity-text-input"
                                        name="citem_qty"
                                        placeholder="Quantity"
                                        validate={{
                                          required: { value: true },
                                        }}
                                      />
                                      {/* <span className="text-danger mt-0">
                                      {this.props.error_msg?.name}
                                    </span> */}
                                    </FormGroup>
                                  </Col>
                                  <Col md={6}>
                                    <FormGroup>
                                      <Label
                                        htmlFor="CProduct-Units-text-input"
                                        className="col-form-label p-0"
                                      >
                                        Units
                                      </Label>

                                      <Select
                                        id="basename"
                                        name="basename"
                                        classNamePrefix="select2-selection"
                                        options={this.props.BasicUnitlist.map(
                                          (item, index) => ({
                                            label: item.name,
                                            value: item.id,
                                          })
                                        )}
                                        value={{
                                          label:
                                            this.props.cPRowData
                                              .baseunitLabel == null
                                              ? "Select Units"
                                              : this.props.cPRowData
                                                  .baseunitLabel,
                                          value:
                                            this.props.cPRowData.baseunit_id,
                                        }}
                                        onChange={(e) => {
                                          this.props.CProductSelecteChangeValue(
                                            {
                                              key: "baseunitLabel",
                                              label: e.label,
                                              key2: "baseunit_id",
                                              value: e.value,
                                            }
                                          );
                                        }}
                                      />
                                      {/* <span className="text-danger mt-0">
                                      {this.props.error_msg?.baseunit_id}
                                    </span> */}
                                    </FormGroup>
                                  </Col>
                                  <Col md={6}>
                                    <FormGroup>
                                      <Label
                                        htmlFor="CProduct-Units-text-input"
                                        className="col-form-label p-0"
                                      >
                                        Deparment
                                      </Label>

                                      <Select
                                        id="Deparment"
                                        name="Deparment"
                                        classNamePrefix="select2-selection"
                                        options={this.props.deparmentslist.map(
                                          (item) => ({
                                            label: item.name,
                                            value: item.id,
                                          })
                                        )}
                                        value={{
                                          label:
                                            this.props.cPRowData
                                              .departmentLabel == null
                                              ? "Select Deparment"
                                              : this.props.cPRowData
                                                  .departmentLabel,
                                          value:
                                            this.props.cPRowData.department_id,
                                        }}
                                        onChange={(e) => {
                                          this.props.CProductSelecteChangeValue(
                                            {
                                              key: "departmentLabel",
                                              label: e.label,
                                              key2: "department_id",
                                              value: e.value,
                                            }
                                          );
                                        }}
                                      />
                                      {/* <span className="text-danger mt-0">
                                      {this.props.error_msg?.baseunit_id}
                                    </span> */}
                                    </FormGroup>
                                  </Col>
                                  <Col md={6}>
                                    <FormGroup className="mb-0">
                                      <Label
                                        htmlFor="CProduct-cdate-text-input"
                                        className="col-form-label p-0"
                                      >
                                        Required Date
                                      </Label>

                                      <AvField
                                        className="mb-0 form-control "
                                        type="date"
                                        min={moment(new Date()).format(
                                          "YYYY-MM-DD"
                                        )}
                                        value={
                                          this.props.cPRowData?.cdate == null
                                            ? moment(new Date()).format(
                                                "YYYY-MM-DD"
                                              )
                                            : this.props.cPRowData?.cdate
                                        }
                                        onChange={this.CPChangeHandeler}
                                        id="CProduct-cdate-text-input"
                                        name="cdate"
                                        placeholder="date"
                                        validate={{
                                          required: { value: true },
                                        }}
                                      />
                                      {/* <span className="text-danger mt-0">
                                      {this.props.error_msg?.name}
                                    </span> */}
                                    </FormGroup>
                                  </Col>
                                  <Col md={12}>
                                    <FormGroup className="mb-0">
                                      <Label
                                        htmlFor="CProduct-cmake-text-input"
                                        className="col-form-label p-0"
                                      >
                                        Make
                                      </Label>

                                      <AvField
                                        className="mb-0 form-control "
                                        type="text"
                                        value={this.props.cPRowData?.cmake}
                                        onChange={this.CPChangeHandeler}
                                        id="CProduct-cmake-text-input"
                                        name="cmake"
                                        placeholder="Add Make"
                                        validate={{
                                          required: { value: true },
                                        }}
                                      />
                                      {/* <span className="text-danger mt-0">
                                      {this.props.error_msg?.name}
                                    </span> */}
                                    </FormGroup>
                                  </Col>
                                  <Col md={8}>
                                    <FormGroup className="mb-0">
                                      <Label
                                        htmlFor="CProduct-cdescription-text-input"
                                        className="col-form-label p-0"
                                      >
                                        Description
                                      </Label>

                                      <AvField
                                        className="mb-0 form-control "
                                        type="textarea"
                                        rows="4"
                                        value={
                                          this.props.cPRowData?.cdescription
                                        }
                                        onChange={this.CPChangeHandeler}
                                        id="CProduct-cdescription-text-input"
                                        name="cdescription"
                                        placeholder="Add Description"
                                        validate={{
                                          required: { value: true },
                                        }}
                                      />
                                      {/* <span className="text-danger mt-0">
                                      {this.props.error_msg?.name}
                                    </span> */}
                                    </FormGroup>
                                  </Col>
                                  <Col md={4}>
                                    <div className="mt-4 ">
                                      <FormGroup className="mb-0">
                                        <Button
                                          block
                                          type="submit"
                                          color="primary"
                                          className="waves-effect waves-light d-inline-block  w-100"
                                          // onClick={() =>
                                          //   this.handleCustomProductSubmit()
                                          // }
                                        >
                                          <i className="mdi mdi-plus mr-1"></i>
                                          Add Item
                                        </Button>

                                        <Button
                                          block
                                          type="button"
                                          color="light"
                                          className="waves-effect waves-light d-inline-block mt-2 w-100"
                                          onClick={() => {
                                            this.props.toggleTab(1);
                                          }}
                                        >
                                          Cancel
                                        </Button>
                                      </FormGroup>
                                    </div>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </AvForm>
                        </div>
                      </TabPane>
                    </TabContent>
                  </Col>
                </Row>
              </Col>
            </Row>
          </ModalBody>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { BasicUnitlist, deparmentslist } = state.Mini;
  const {
    error_msg,
    activeTab,
    params,
    productslist,
    productsCount,
    dataLoading,
    productRowlist,
    productRowdata,
    cPRowData,
    cPimage,
    imagePreviewUrl,
    rowdata,
    mrRowData,
    model,
    locId,
    deptId,
    productStoreQty,
    loading,
  } = state.Servicerequest;
  return {
    error_msg,
    activeTab,
    params,
    productslist,
    productsCount,
    dataLoading,
    productRowlist,
    productRowdata,
    BasicUnitlist,
    deparmentslist,
    cPRowData,
    cPimage,
    imagePreviewUrl,
    rowdata,
    mrRowData,
    model,
    locId,
    deptId,
    productStoreQty,
    loading,
  };
};

export default connect(mapStatetoProps, {
  InputChangeValue,
  SelecteChangeValue,
  getAllProducts,
  getRowProducts,
  SelectedProducts,
  model_open,
  model_close,
  CProductImage,
  CProductChangeValue,
  CProductSelecteChangeValue,
  AddCustomProduct,
  SetParams,
  toggleTab,
  uploadMultipleSRItemImages,
})(AddServiceItem);
